import React, { FC } from 'react';
import { IconType } from '@app/components/ui/icons/icon.type';

const WidgetFlame: FC<IconType> = (props) => {
  const { size, className, customStyle } = props;
  return (
    <div className={className}>
      <svg
        style={customStyle}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M12 22c4-2 8-6 8-10a8 8 0 00-8-8c-1 3-3 5-5 6a5 5 0 00-3 4c0 5 4 8 8 8z" />
      </svg>
    </div>
  );
};

export default WidgetFlame;
